import gql from 'graphql-tag';

export const generateSubKeyMutation = gql`
  mutation ($input: GenerateSubKeyInput) {
    generateSubKey(input: $input)
    {
      subKeyId
      alias
      type
      key
    }
  }
`
